<template>
  <div ref="userScroll">
  <!-- <div class="nursing-one" @click.capture="nursingCapture"> -->
    <div class="filter-container">
      <el-drawer
      class="drawer"
      direction="ltr"
      size="71%"
      :visible.sync="swtich"
      :before-close="handleClose"
      :with-header="false">
        <div class="filter" v-loading.fullscreen.lock="filterscreenLoading">
          <div class="close-swtich" @click="handleClose">
            <span class="title">收缩</span>
            <el-image
                class="left-image"
                slot="prefix"
                :src="nvaLeft"
              fit="contain"></el-image>
          </div>
          <el-menu
              class="el-menu-vertical-demo"
              background-color="#fff"
              text-color="#000">
              <template>
                <el-submenu index="1">
                  <template slot="title">
                    <span class="title">楼栋</span>
                  </template>
                  <el-menu-item  index="1-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:0})" v-model="activeBuildings" >
                      <el-checkbox-button v-for="building in buildingAreas" :label="building.Name" :key="building.Name">{{building.Name}}</el-checkbox-button>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="2">
                  <template slot="title">
                    <span class="title">楼层</span>
                  </template>
                  <el-menu-item  index="2-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:1})" v-model="activeFloors" >
                      <template  v-for="building in buildingAreas">
                        <template v-for="floor in building.Floors">
                          <el-checkbox-button v-if="activeBuildings.length==0||activeBuildings.indexOf(building.Name)!=-1" :key="floor.Name" :label="building.Name+'||'+floor.Name">{{floor.Name}}</el-checkbox-button>
                        </template>
                      </template>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="3">
                  <template slot="title">
                    <span class="title">房间</span>
                  </template>
                  <el-menu-item  index="3-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:2})" v-model="activeRomms" >
                      <template  v-for="building in buildingAreas">
                        <template v-if="activeBuildings.length==0||activeBuildings.indexOf(building.Name)!=-1">
                          <template  v-for="floor in building.Floors">
                            <template v-if="activeFloors.length==0||activeFloors.indexOf(building.Name+'||'+floor.Name)!=-1">
                              <el-checkbox-button v-for="room in floor.Rooms" :key="room" :label="building.Name+'||'+floor.Name+'||'+room">
                                {{room}}
                              </el-checkbox-button>
                            </template>
                          </template>
                        </template>
                      </template>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
              </template>
            </el-menu>
        </div>
      </el-drawer>
    </div>
    <div class="head">
        <div class="btnFilter">
          <div @click="openFilter()" class="btnFilter-btn">
                <el-image
                class="btnFilter-image"
                :src="shaixuan"></el-image>
                <span>筛选</span>
            </div>
        </div>
        <el-input
          class="search"
          placeholder="搜索长者"
          v-model="keyword">
          <el-image
          class="search-image"
          slot="prefix"
          :src="sousuo"
          fit="contain"></el-image>
        </el-input>
        <div class="weekDate" @click="CalendarShow=true,triangle='triangle_down'">
          <div>{{ startWeek + '至' + endWeek }}</div><div :class="triangle"></div>
        </div>
      </div>
    <div class='nursingItem-list' v-loading="loading">
        <div @click="goImplement(item.Id)" class="nursingItem-container" v-for="(item,index) in tableData" :key="index">
          <div class="nursing-item">
            <div class="left">
                <el-image
                class="nursing-image"
                fit="cover"
                :src="item.Url || avatar"></el-image>
                <div class="name-message">
                    <p class="name-message-main">
                        <span class="name">{{item.Name}}</span>
                    </p>
                    <p class="room-message">
                        <span class="room">房号:</span>
                        <span class="room-num">{{item.RoomNo}}</span>
                    </p>
                </div>
            </div>
            <div class="right">
                <div class="fd-item-detail">
                  <div class="fd-item-date" v-for="date in item.List" :key="date.Week">
                    <div class="fd-item-round" :style="{'background-color':date.IsMessage==0?'rgb(245, 63, 63)':'#67c23a'}"></div>
                    <div>{{date.DT.replace(/-/g,'.')}}/{{date.Week | filterWeek}}</div>
                  </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    <van-calendar v-model="CalendarShow" type="range" first-day-of-week="1" :show-confirm="false" color="#029fd1" allow-same-day :default-date="defaultDate" :min-date="getMinDate()" @close="triangle='triangle_up',
      CalendarShow=false" @select="selectDate" />
    <pager @changePage="changePage" @changeSize="changeSize" :page='page+1' :total="total" :size="size"></pager>
  </div>
</template>

<script>
import shaixuan from '@/assets/imgs/icon-shaixuan-32@2x.png'
import pager from '@/common/pager.vue'
import sousuo from "@/assets/imgs/icon-sousuo-32@2x.png";
import avatar from "@/assets/imgs/avatar.png";
import nvaLeft from '@/assets/imgs/left@2x (2).png'
import { intitime } from '@/tool'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    pager
  },
  filters: {
    filterWeek(week){
      switch (week) {
          case 1:
            return '周一'
          case 2:
            return '周二'
          case 3:
            return '周三'
          case 4:
            return '周四'
          case 5:
            return '周五'
          case 6:
            return '周六'
          case 7:
            return '周天'
          default:
            break;
      }
    }
  },
  // 组件状态值
  data () {
   return {
    userId: '',
    swtich: false,
    filterscreenLoading: false,
    shaixuan,
    avatar,
    nvaLeft,
     keyword:"",
     size:10,
     page:0,
     total:10,
     sousuo,
     startWeek: '',
    endWeek: '',
    defaultDate: [],
    triangle: 'triangle_up',
    CalendarShow: false,
    buildingAreas: [],
    districtData: [],
    FloorData: [],
    roomData: [],
    //选中楼区 楼层 房间
    activeBuildings: [],
    activeFloors:[],
    activeRomms:[],
    userList: [],
    filterUserList: [],
    // 分页后每页显示的长者列表
    tableData: [],
    areaArr: [],
    floorArr: [],
    roomArr: [],
    loading: false
   }
  },
  watch:{
      keyword:{
          immediate:true,
          handler(newValue){
              this.filterUser()
          }
      }
  },
  // 组件方法
  methods: {
    handleClose(){
      this.swtich = false
    },
    openFilter(){
      this.swtich = true
    },
    goImplement(Id){
      this.$router.push({
        name:"mealsPlan",
        query: { 'Id':Id, 'startWeek': this.startWeek, 'endWeek':this.endWeek }
      })
    },
    //获取当前日期周一
    getFirstDayOfWeek(date){
      var day =date.getDay() || 7;
      return new Date(date.getFullYear(),date.getMonth(),date.getDate()+1-day);
    },
    //获取当前日期周天
    getLastDayOfWeek (date) {
      var day = date.getDay() || 7;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()+7 - day);
    },
    getMinDate(){
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30 * 5);
      return date
    },
    // 选择日期
    selectDate(event){
      let date = new Date(event[0])
      this.CalendarShow = false
      this.triangle = 'triangle_up'
      this.startWeek = intitime(this.getFirstDayOfWeek(date), 'yyyy-MM-dd')
      this.endWeek = intitime(this.getLastDayOfWeek(date), 'yyyy-MM-dd')
      this.defaultDate = [this.getFirstDayOfWeek(date), this.getLastDayOfWeek(date)]
      this.QueryResidentElderly()
    },
    // 查询长者列表
    QueryResidentElderly(){
      this.loading = true
      this.$axios.get("/Pad/QueryResidentElderly?startWeek="+this.startWeek+"&endWeek="+this.endWeek).then((res) => {
        this.loading = false
        this.userList = res.data.obj
        this.filterUserList = res.data.obj
        // 将长者列表分页显示
        this.getTabelData()
      }).catch((err) => {
          this.loading = false
          this.$message.error({
              message:'服务器异常，稍后再试',
              offset: 100
            });
        });
    },
    // 左侧筛选条件
    localUpdateFilter({type,arr}){
      switch (type) {
          case 0:
            this.areaArr = arr
            this.floorArr = []
            this.roomArr = []
            this.activeFloors = []
            this.activeRomms = []
            break;
          case 1:
            this.floorArr = arr
            this.roomArr = []
            this.activeRomms = []
            break;
          case 2:
            this.roomArr = arr
            break;
          default:
            break;
      }
      if (this.roomArr.length > 0) {
        this.filterUser([], this.roomArr)
      } else if (this.floorArr.length > 0) {
        let floorArr = []
        this.floorArr.forEach(floor => {
          floorArr.push(floor.split('||')[1])
        })
        this.filterUser(floorArr, [])
      } else if (this.areaArr.length > 0) {
        let floorArr = []
        this.areaArr.forEach(area => {
            this.buildingAreas.forEach(build => {
              if (area === build.Name) {
                build.Floors.forEach(floor => {
                  floorArr.push(floor.Name)
                })
              }
            })
        })
        this.filterUser(floorArr, [])
      } else {
        this.filterUser([], [])
      }
    },
    // 数据过滤
    filterUser(floorArr, roomArr){
      this.filterUserList = this.userList.filter((person)=>{
          return person.Name.indexOf(this.keyword) !== -1;
      })
      let filterUserList = []
      if (floorArr && floorArr.length>0) {
        floorArr.forEach(floor => {
          console.log('floor', floor)
          this.filterUserList.forEach(user => {
            if (user.FloorName === floor) {
              filterUserList.push(user)
            }
          })
        })
        this.filterUserList = filterUserList
      }
      if (roomArr && roomArr.length>0) {
        roomArr.forEach(room => {
          console.log('room.split('||')[2]', room.split('||')[2])
          this.filterUserList.forEach(user => {
            if (user.RoomNo === room.split('||')[2]) {
              filterUserList.push(user)
            }
          })
        })
        this.filterUserList = filterUserList
      }
      this.total=this.filterUserList.length
      if(this.page*this.size>=this.total){
          this.page=0
      }
      console.log('filterUserList', this.filterUserList)
      this.getTabelData()
    },
    // 查询长者筛选数据
    searchData() {
      this.loading = true
      this.$axios.post('/Pad/FilterQuery?userId=' + this.userId).then((response) => {
        this.loading = false
        if (response.data.ok) {
              const filtrate = response.data.obj;
              console.log('filtrate', filtrate)
              this.buildingAreas = filtrate.BuildingAreas;
              this.QueryResidentElderly()
              var districtData = [];
            // 遍历项目楼栋中的小类
            this.buildingAreas.forEach(item => {
                districtData.push({
                    Name: item.Name,
                    checked: false,
                    parent: item.Name,
                    child: item.Floors,
                })
            })
            this.districtData = districtData;
            var floorData = [];
            // 遍历项目楼栋中的小类
            this.districtData.forEach(item => {
                item.child.forEach(ite => {
                    floorData.push({
                        Name: ite.Name,
                        parent: item.Name,
                        child: ite.Rooms,
                        checked: false
                    })
                })
            })
            this.floorData = floorData;
            var roomData = [];
            // 遍历项目楼栋中的小类
            this.floorData.forEach(item => {
                item.child.forEach(ite => {
                    roomData.push({
                        parent: item.parent,
                        Name: ite,
                        parent1: item.Name,
                        checked: false
                    })
                })
            })
            this.roomData = roomData;
            } else {
                this.$message.error({
                  message: response.msg,
                  offset: 100
                });
            }
        }), err => {
          this.loading = false
            return false;
        };
    },
    //自行分页
    getTabelData() {
      let data=JSON.parse(JSON.stringify(this.filterUserList))
      this.tableData = data.splice((this.page) * this.size,this.size);
      this.total=this.filterUserList.length
      this.$nextTick(function(){
        this.$refs.userScroll.scrollTo(0, 0)
      })
    },
    //page改变时的回调函数，参数为当前页码
     changePage(val) {
      console.log("翻页，当前为第几页", val);
      this.page = val;
      this.getTabelData();
    },
    //size改变时回调的函数，参数为当前的size
    changeSize(val) {
      console.log("改变每页多少条，当前一页多少条数据", val);
      this.size = val;
      this.page = 0;
      this.getTabelData();
    }

  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {

  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {
    var token = JSON.parse(localStorage.getItem('user'));
    this.userId = token.UserId
    this.startWeek = intitime(this.getFirstDayOfWeek(new Date()), 'yyyy-MM-dd'),
    this.endWeek = intitime(this.getLastDayOfWeek(new Date()), 'yyyy-MM-dd')
    this.defaultDate = [this.getFirstDayOfWeek(new Date()), this.getLastDayOfWeek(new Date())]
    this.searchData()
  }
}
</script>

<style scoped>
.btnFilter{
  width: 61px;
  height: 24px;
  padding: 0px !important;
  border: 1px solid #029FD1;
  color: #029FD1;
  line-height:24px;
  border-radius: 12px !important;
  background-color: #fff;
  box-sizing: border-box;
}
.btnFilter-btn{
  display: flex;
  width: 61px;
  height: 24px;
  border-radius: 12px !important;
  line-height: 24px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #029FD1;
  margin-left: -2px;
  margin-top: -1px;
}
.btnFilter-image{
  width: 16px;
  height: 16px;
}

.head{
  position: fixed;
  top: 42px;
  left: 0px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  z-index: 1;
  flex-wrap: wrap;
}

.search-image{
  width: 16px;
  height: 16px;
  margin: 9px 4px 10px 10px;
}
.search,.head >>> .el-input__inner{
  width: 240px;
  height: 35px;
  font-size: 12px;
  background: #F4F4F4;
  border:1px solid #F4F4F4;
}
.search{
  font-size: 14px;
}
.head >>> .el-input--prefix .el-input__inner{
  padding-left: 32px;
}

.weekDate{
  font-size: 14px;
  color: #646566;
  font-weight: bold;
  display: flex;
  padding-top: 15px
}
.triangle_up{
  width: 0px;
  height: 0px;
  border: 8px solid transparent;
  border-top-color: #646566;
  position: relative;
  top: 5px;
  margin-left: 3px;
}

.triangle_down{
  width: 0px;
  height: 0px;
  border: 8px solid transparent;
  border-bottom-color: #909399;
  position: relative;
  top: -3px;
  margin-left: 3px;
  transform: rotate(360deg);
}

.drawer{
  top: 44px;
  height: calc(100vh - 44px);
}

.filter{
  width: 266px;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
}
.filter >>> .el-menu-item{
  padding: 0px !important;
}
.filter >>> .el-checkbox-group{
  display: flex;
  flex-flow: wrap;
}
.filter >>> .el-checkbox-button{
  width: 100px;
}
.filter >>> .el-checkbox-button{
  margin: 10px 6px 10px 0px;
}

.filter >>> .el-checkbox-button__inner{
  width: 100%;
  border-radius: 2px !important;
    padding: 6px 6px;
  border: 1px solid #C7C9CC;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #434649;
}
.filter >>> .el-submenu__title{
  padding: 0px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.filter >>> .el-menu-item{
  background-color: rgba(0, 0, 0, 0) !important;
}

.filter >>> .el-submenu .el-menu-item,.filter >>> .el-menu-item,.filter >>> .el-submenu__title{
  height: auto ;
}


.filter >>> .is-checked .el-checkbox-button__inner{
  background: #029FD1 !important;
  color: #fff !important;
}
/* .filter >>> .is-focus .el-checkbox-button__inner:hover{

} */


.close-swtich{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  margin:0px 10px 10px 0px;
}
.left-image{
  width: 16px;
  height: 16px;
  margin-left: 3px;
}
.v-enter-active,.v-leave-active {
  transition: all .3s ease;
}
.v-enter-to{
  margin-left: 0px;
}
.v-enter,.v-leave-to{
  margin-left: -115px;
}

.el-menu{
  border-right: none;
}
.title{
  font-size: 16px;
  color: #0A0E10;
  font-weight: 500;
  font-family: 'PingFang SC Medium';
}

.nursingItem-container{
  margin: 12px 0px;
  background: #fff;
  border-radius: 4px;
}
.nursingItem-list{
  padding: 100px 10px 60px 10px;
  background-color: #f7f8fa;
  min-height: 400px;
}
.nursing-item{
    padding: 0px 12px 0px 12px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.left{
    display: flex;
    align-items: flex-start;
}
.nursing-image{
    width: 42px;
    height: 42px;
    border-radius: 21px;
    margin-right: 8px;
    border: 1px solid #029FD1;
    box-sizing: border-box;
    margin-top: 6px;
    /* box-shadow: 0px 0px 10px 0px #888888; */
}
.name-message-main,.room-message{
    margin: 5px 0px 0px 0px;
}
.name-message-main{
    vertical-align: middle;
}
.name{
    font-family: 'PingFang SC Medium';
    font-size: 16px;
    font-weight: 500;
    color: #0A0E10;
    margin-right: 5px;
}
.message{
    font-size: 12px;
    font-weight: 400;
    color: #7C7E80;
}
.room-message{
    font-size: 12px;
    font-weight: 400;
    color: #029FD1;
}
.right{
    font-size: 8px;
    text-align: center;
    width: 54%;
    padding: 10px 0px;
}
.badge{
    position: relative;
    margin: 13px 0px;
}
.totalCare{
    position: absolute;
    right: -8px;
    top: -8px;
    width: 16px;
    height: 16px;
    line-height: normal;
    background: #F22D2E;
    border-radius: 50%;
}
.three-num-span{
    line-height: 1;
    color: #fff;
    font-size: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%) scale(0.5,0.5);
}
.project{
    width: 75px;
    height: 24px;
    line-height: 24px;
    background: #DEF7FF;
    border-radius: 2px;
    text-align: center;
    color: #029FD1;
    font-family: 'PingFang SC Medium';
}
.await{
    width: 75px;
    height: 24px;
    line-height: 24px;
    color: #7D4304;
    background: #FEF3E7;
    border-radius: 2px;
    text-align: center;
    font-family: 'PingFang SC Medium';
}
.right >>> .el-badge__content{
    padding: 6px 2px;
    border-radius: 12px;
    min-width: 19px;
    font-size: 8px;
    right: 11px;
}
.fd-item-detail {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    border-radius: 4px;
    background: #F7F8FA;
}

.fd-item-round {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 5px;
    border-radius: 50%;
    transform: translate(0,34%);
}

.fd-item-date {
    width: 50%;
    display: flex;
    margin-bottom: 10px;
    color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/components/mealsPlan/userList.vue